import { getLocalizedString } from "@grandvisionhq/utils";
const mapAppliedCartDiscounts = (cartAppliedDiscounts, locale) => {
  if (!cartAppliedDiscounts) {
    return [];
  }
  return cartAppliedDiscounts?.map((discount) => ({
    title: getLocalizedString(discount.title, locale),
    description: getLocalizedString(discount.description, locale),
    code: discount.code || null,
    type: discount.type
  }));
};
export {
  mapAppliedCartDiscounts
};
//# sourceMappingURL=map-applied-cart-discounts.js.map
